import { createSlice } from "@reduxjs/toolkit";

const authState = (() => {
  try {
    const raw = localStorage.getItem("roha_auth");
    return raw ? JSON.parse(raw) : { token: null, user: null };
  } catch {
    return { token: null, user: null };
  }
})();

const authSlice = createSlice({
  name: "auth",
  initialState: authState,
  reducers: {
    setCredentials: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      localStorage.setItem("roha_auth", JSON.stringify({ token: state.token, user: state.user }));
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      localStorage.removeItem("roha_auth");
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
